import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type {
    Report,
    ReportHistoricalFilter,
} from "@report/domain/models/report.model";
import type { ReportRepository } from "@report/domain/repositories/report.repository";
import { reportTypes } from "@report/report-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ReportGetHistoricalPoisVisitedUsecase {
    constructor(
        @inject(reportTypes.repositories.ReportRepository)
        private readonly reportRepository: ReportRepository,
    ) {}

    async execute(
        historicalFilters: ReportHistoricalFilter,
    ): Promise<Report[]> {
        const historicalReportResult =
            await this.reportRepository.fetchPoisVisitedReport(
                historicalFilters,
            );

        if (historicalReportResult.isErr()) {
            ToastManagerRepository.error(historicalReportResult.error.message);
        }
        return historicalReportResult.match(
            (historicalReport) => historicalReport,
            () => [],
        );
    }
}
